export const NUTRITION_TOUR_ID = 'patient-nutrition'

export const NUTRITION_ONBOARDING_STEPS = [
  {
    title: 'Alimentação no prontuário',
    body: 'Esta aba acompanha as refeições, o aceite do dia e a água livre. O cardápio fica nas prescrições e o que foi servido aparece na linha do tempo.',
  },
  {
    target: '[data-onboarding="nutrition-summary"]',
    title: 'Resumo do dia',
    body: 'Os cartões mostram a água consumida contra a meta, o aceite médio das ofertas já lançadas e quantas fórmulas estão abaixo do estoque mínimo.',
  },
  {
    target: '[data-onboarding="nutrition-timeline"]',
    title: 'Linha do tempo',
    body: 'As refeições do dia ficam por horário. Em cada uma dá para registrar 100%, aceite parcial ou recusa, e lançar água livre.',
  },
  {
    target: '[data-onboarding="nutrition-plates"]',
    title: 'Prescrições nutricionais',
    body: 'Cada card é um prato reutilizável. Arraste pelo ícone de mover até a linha do tempo e escolha o horário, o início e o fim.',
  },
  {
    target: '[data-onboarding="nutrition-stock"]',
    title: 'Estoque de fórmulas',
    body: 'O saldo vale só para a fórmula enteral. O badge amarelo ou vermelho avisa quando está acabando. Recarregar estoque soma as unidades compradas.',
  },
]
